export default "__VITE_ASSET__C8MXEWbk__"